import FileCopyIcon from "@mui/icons-material/FileCopy";
import RateReviewIcon from "@mui/icons-material/RateReview";
import VisibilityIcon from "@mui/icons-material/Visibility";

import { Product } from "api/memberPortal/project/product/product.types";
import ActionsCell from "components/MUI/DataGrid/Cells/Actions/Actions.cell";
import IconMenuLink from "components/MUI/DataGrid/Cells/Actions/IconMenuLink";

import DeleteDraftAction from "./actions/Delete.action";
import ValidationTeamAction from "./actions/ValidationTeam.action";

interface ProductTableActionsCellProps {
  product: Product;
  setProduct: (_product: Product) => void;
  setShowDeleteModal: (_show: boolean) => void;
  setShowAmValTeamModal: (_show: boolean) => void;
  setShowValTeamModal: (_show: boolean) => void;
}

const ProductTableActionsCell = ({
  product,
  setProduct,
  setShowDeleteModal,
  setShowAmValTeamModal,
  setShowValTeamModal,
}: ProductTableActionsCellProps) => {
  return (
    <ActionsCell id={product.v_id || product.product_id}>
      <DeleteDraftAction
        product={product}
        setProduct={setProduct}
        setShowDeleteModal={setShowDeleteModal}
      />
      <IconMenuLink
        Icon={VisibilityIcon}
        label="View"
        to={`./details/${product.product_id}`}
      />
      <IconMenuLink
        Icon={RateReviewIcon}
        label="ECR Comments"
        to={`/community/ecr-comments/${product.v_id}`}
      />
      <IconMenuLink
        Icon={FileCopyIcon}
        label="Files"
        to={`/community/products/details/${product.product_id}/product/files`}
        enabled={true}
      />
      <ValidationTeamAction
        product={product}
        setProduct={setProduct}
        setShowValTeamModal={setShowValTeamModal}
        setShowAmValTeamModal={setShowAmValTeamModal}
      />
    </ActionsCell>
  );
};

export default ProductTableActionsCell;
